import {
  AfterContentInit,
  Component,
  Directive,
  Input,
  NgModule,
} from '@angular/core';
import {NgTemplateOutlet} from '@angular/common';
import {CdkStep, CdkStepper, CdkStepperModule} from '@angular/cdk/stepper';

@Component({
  selector: 'sd-step',
  standalone: true,
  providers: [{provide: CdkStep, useExisting: SdStep}],
  template: `<ng-template><ng-content></ng-content></ng-template>`,
})
export class SdStep extends CdkStep {
  @Input() label = '';
}

@Component({
  selector: 'sd-stepper, sd-horizontal-stepper, sd-vertical-stepper',
  exportAs: 'sdStepper',
  standalone: true,
  imports: [NgTemplateOutlet],
  providers: [{provide: CdkStepper, useExisting: SdStepper}],
  template: `
    <div class="sd-stepper flex flex-col gap-4" [class.sd-stepper--vertical]="orientation === 'vertical'">
      <ol class="m-0 flex list-none flex-wrap gap-2 p-0" [class.flex-col]="orientation === 'vertical'">
        @for (step of steps; track $index) {
          <li class="flex items-center gap-2 text-sm">
            <span class="inline-flex h-6 w-6 items-center justify-center rounded-full text-xs font-semibold"
                  [class.bg-[var(--m365-accent,#111)]]="$index === selectedIndex"
                  [class.text-white]="$index === selectedIndex"
                  [class.bg-neutral-200]="$index !== selectedIndex">{{ $index + 1 }}</span>
            <span [class.font-semibold]="$index === selectedIndex">{{ stepLabel($index) }}</span>
          </li>
        }
      </ol>
      <div class="sd-stepper__body">
        <ng-container [ngTemplateOutlet]="selected?.content || null"></ng-container>
      </div>
    </div>
  `,
  host: {class: 'sd-stepper-host sd-stepper block'},
})
export class SdStepper extends CdkStepper implements AfterContentInit {
  @Input() override linear = false;

  stepLabel(index: number): string {
    const step = this.steps?.get(index) as SdStep | undefined;
    return step?.label || `Step ${index + 1}`;
  }
}

@Directive({
  selector: '[sdStepperNext]',
  standalone: true,
  host: {'(click)': 'stepper.next()'},
})
export class SdStepperNext {
  constructor(public stepper: SdStepper) {}
}

@Directive({
  selector: '[sdStepperPrevious]',
  standalone: true,
  host: {'(click)': 'stepper.previous()'},
})
export class SdStepperPrevious {
  constructor(public stepper: SdStepper) {}
}

@NgModule({
  imports: [CdkStepperModule, SdStep, SdStepper, SdStepperNext, SdStepperPrevious],
  exports: [SdStep, SdStepper, SdStepperNext, SdStepperPrevious],
})
export class SdStepperModule {}
